import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const ReliefText = ({ observations, cancelAction }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <h3 className="title">{t(`forms.turnHistory.reliefObservation`)}</h3>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-12 col-md-11 marg-btm-1rem">
          <h5>{t(`forms.turnHistory.reliefObservationText`)}</h5>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-12 col-md-11 mt-2">
          <p>
            {observations ? observations : "No hay observaciones disponibles"}
          </p>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-10 col-sm-11 text-center mt-5 mb-5">
          <button
            type="button"
            onClick={() => cancelAction()}
            className="btn btn-lg btn-secondary me-2"
          >
            {t(`forms.turnHistory.buttons.acceptRelief`)}
          </button>
        </div>
      </div>
    </>
  );
};

ReliefText.propTypes = {
  reliefText: PropTypes.string,
};

export default ReliefText;
